<template>
	<form>
		<header class="mb-4">
			<h3><strong>Registrasi</strong></h3>
		</header>
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Jenis Akun
			</strong>
			<v-select
			    v-model="accountType"
			    :options="accountOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- Nama -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Nama
			</strong>
			<vs-input
				:class="!errors.has('name') ? 'w-full mb-4' : 'w-full'"
			    v-model="name"
			    v-validate="'required|alpha_spaces'"
			    placeholder="Nama"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="name"
			    :danger="errors.has('name')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('name')">
				<strong>{{ errors.first('name') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Phone -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				No. Handphone/Whatsapp
			</strong>
			<vs-input
				:class="!errors.has('no_telp') ? 'w-full mb-4' : 'w-full'"
				type="number"
			    v-model="no_telp"
			    v-validate="'required|min:10'"
			    placeholder="No. Handphone/Whatsapp"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="no_telp"
			    :danger="errors.has('no_telp')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('no_telp')">
				<strong>{{ errors.first('no_telp') }}</strong>
			</span>
		</div>
		<div class="form-group mb-4" v-if="accountType ? accountType.label == 'User' : '' ">
				<strong class="block mb-2">
					Alamat
				</strong>
				<vs-input
					type="text"
					placeholder="Alamat"
					v-model="alamat"
					class="w-full rounded"
					name="alamat"
				/>
		</div>
		<div class="form-group mb-4" v-if="accountType ? accountType.label == 'User' : '' ">
				<strong class="block mb-2">
					Provinsi
				</strong>
				<v-select
					v-model="provinsi"
					class="w-full rounded"
					:options="provOptions"
				/>
		</div>
		<div class="form-group mb-4" v-if="accountType ? accountType.label == 'User' : '' ">
				<strong class="block mb-2">
					Kota/Kabupaten
				</strong>
				<v-select
					v-model="kota"
					class="w-full rounded"
					:options="kotaOptions"
				/>
		</div>
		<div class="form-group mb-4" v-if="accountType ? accountType.label == 'User' : '' ">
				<strong class="block mb-2">
					Kecamatan
				</strong>
				<v-select
					class="w-full rounded"
					v-model="kecamatan"
					:options="kecamatanOptions"
				/>
		</div>
		<!-- / -->
		<!-- Email -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Email
			</strong>
			<vs-input
				:class="!errors.has('email') ? 'w-full mb-4' : 'w-full'"
			    v-model="email"
			    v-validate="'required|email'"
			    placeholder="Email"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="email"
			    :danger="errors.has('email')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('email')">
				<strong>{{ errors.first('email') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Kata Sandi -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Kata Sandi
			</strong>
			<vs-input
				type="password"
				ref="password"
				:class="!errors.has('password') ? 'w-full mb-4' : 'w-full'"
			    v-model="password"
			    v-validate="'required|min:6'"
			    placeholder="Kata Sandi"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="password"
			    :danger="errors.has('password')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('password')">
				<strong>{{ errors.first('password') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Konfirmasi Kata Sandi -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Konfirmasi Kata Sandi
			</strong>
			<vs-input
				type="password"
				:class="!errors.has('confirm_password') ? 'w-full mb-4' : 'w-full'"
			    v-model="confirm_password"
			    v-validate="'required|confirmed:password'"
			    placeholder="Konfirmasi Kata Sandi"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="confirm_password"
			    :danger="errors.has('confirm_password')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('confirm_password')">
				<strong>{{ errors.first('confirm_password') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Checkbox -->
		<div class="form-group flex mb-4">
			<vs-checkbox v-model="agree" />
			<strong class="text-grey">
			Saya setuju dengan 
			<a href="#" @click.prevent="showPopup('terms_conditions')">syarat dan ketentuan</a> dan 
			<a href="#" @click.prevent="showPopup('privacy_policy')">kebijakan privasi</a>
			</strong>
		</div>
		<!-- / -->
		<vs-button color="primary" @click.prevent="register" class="w-full rounded mb-6">Buat Akun</vs-button>
		<p class="text-primary text-center">Sudah punya akun? <router-link to="login">
			<strong>Masuk sekarang</strong>
		</router-link></p>

		<!-- Terms popup -->
		<vs-popup
			fullscreen
			title="Syarat & Ketentuan"
			:active.sync="show_term"
		>
			<div v-html="terms_conditions"></div>
		</vs-popup>
		<!-- / -->
		<!-- Privacy Policy -->
		<vs-popup
			fullscreen
			title="Kebijakan Privasi"
			:active.sync="show_privacy"
		>
			<div v-html="privacy_policy"></div>
		</vs-popup>
		<!-- / -->
	</form>
</template>
<script>
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

const dict = {
  custom: {
    name: {
      required: 'Harap isi nama lengkap',
      alpha_spaces: 'Nama hanya boleh huruf dan spasi'
    },
    email: {
		      required: 'Harap masukan email',
		      email: 'Harap masukan email yang valid, contoh: yourmail@gmail.com'
		    },
		    no_telp: {
		    	required: 'Harap masukan nomer telepon anda',
		    	min: 'Nomer telepon minimal 11 angka'
		    },
		    password: {
		    	required: 'Harap masukan password',
		    	min: 'Password minimal 6 karakter'
		    },
		    confirm_password: {
		    	required: 'Harap masukan konfirmasi password',
		    	confirmed: 'Password tidak sama'
		    }
  }
}

Validator.localize('en', dict)

export default {
	computed: {
		...mapState('auth', ['registeredData']),
    	...mapState('about', ['terms_conditions', 'privacy_policy'])
	},
  components: {
    vSelect
  },
  mounted () {
    this.getProvinsi()
  },
  data: () => ({
    agree: null,
    name: null,
    email: null,
    no_telp: null,
    password: null,
	show_term: false,
	show_privacy: false,
    confirm_password: null,
    accountOptions: [
      {id: 4, label: 'User'},
      {id: 3, label: 'Sahabat ZX'}
    ],
    accountType: null,
	provinsi: null,
    kota: null,
    kecamatan: null,
	alamat:null,
	kotaOptions: [],
    kecamatanOptions: [],
	provOptions: [
      {
        id: 1,
        label: 'Jawa Barat'
      },
      {
        id: 2,
        label: 'DKI Jakarta'
      }
    ],
    data: null
  }),
  watch : {
	provinsi (val) {
      if (val !== null) {
			this.getKota(val.id)
			this.params = {
				provinsi_id: val.id
        	}
		}
	},
	kota (val) {
		if (val !== null) {
			this.params = {
				provinsi_id: this.provinsi.id,
				kabkot_id: val.id
			}
			this.getKecamatan(val.id)
		}
	},
	kecamatan(val) {
    	if (val !== null) {
			this.params = {
				provinsi_id: this.provinsi.id,
				kabkot_id: this.kota.id,
				kecamatan_id: this.kecamatan.id,
			}
			
		}
	}
  },
  methods: {
	getKecamatan (kota_id) {
      this.$vs.loading()
      this.$store.dispatch('region/getKecamatan', {kabkot_id:kota_id})
        .then(kecamatan => {
          this.$vs.loading.close()
          kecamatan.forEach(item => {
          	item.label = item.name
          })
          this.kecamatanOptions = kecamatan
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    getKota (provinsi_id) {
      this.$vs.loading()
      this.$store.dispatch('region/getKota', {provinsi_id})
        .then(kota => {
          this.$vs.loading.close()
          kota.forEach(item => {
          	item.label = item.name
          })
          this.kotaOptions = kota
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    getProvinsi () {
      this.$store.dispatch('region/getProvinsi')
        .then(provinsi => {
          provinsi.forEach(item => {
          	item.label = item.name
          })
          this.provOptions = provinsi
        })
        .catch(e => {
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
	showPopup(type = 'terms_conditions') {
		if(type === 'terms_conditions') {
			this.show_term = true
			this.show_privacy = false
		}
		else {
			this.show_term = false
			this.show_privacy = true
		}
	},
    register () {
      if (this.accountType == null) {
        this.$vs.notify({
          title: 'Harap pilih peran pendaftar',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      if (!this.agree) {
        this.$vs.notify({
          title: 'Harap setujui syarat dan ketentuan',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false	
      }

      this.$validator.validateAll().then((res) => {
        if (res) {
        	// set registered user
        	this.$store.dispatch('auth/saveRegisterData', {
        		name: this.name,
        		email: this.email,
        		no_telp: this.no_telp,
				provinsi_id : this.provOptions.id,
				kabkot_id : this.kotaOptions.id,
				kec_id : this.kecamatanOptions.id,
		        password: this.password,
		        level_id: this.accountType.id,
				alamat : this.alamat,
		        level_key: this.accountType.label.toLowerCase()
        	})

        	// emit to main component
        	this.$emit('register', { name: this.name,
        		email: this.email,
        		no_telp: this.no_telp,
		        password: this.password,
		        level_id: this.accountType.id,
				provinsi_id : this.provOptions.id,
				kabkot_id : this.kotaOptions.id,
				kec_id : this.kecamatanOptions.id,
				alamat : this.alamat,
		        level_key: this.accountType.label.toLowerCase()
        	})	
        } else {
          return false
        }
						
      })
    },
	getTermAndPrivacy() {
		this.$vs.loading()
		this.$store.dispatch('about/index')
		.then(() => {
			this.$vs.loading.close()
		})
		.catch(e => {
			this.$vs.loading.close()
			if (e.response) console.error(e.response)

			return false
		})
	}
  },
  created() {
  	if(this.registeredData) {
  		this.data = {}
  		Object.assign(this.data, this.registeredData)

  		if(this.data !== null) {
  			this.name = this.data.name
  			this.email = this.data.email
  			this.no_telp = this.data.no_telp
  		}
  	}

	this.getTermAndPrivacy()
  },
  
}
</script>